
import { Component, OnDestroy, ViewChild, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ItemService } from '@services/item.service';
import { NotificationService } from '@services/notification.service';
import { QuestionService } from '@services/question.service';
import { RoleManagementService } from '@services/role.management.service';
import { Subject, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { CreateNewItemComponent } from '../create-new-item/create-new-item.component';
import { WebErrorService } from '@services/webError.service';
import { CollectionService } from '@services/collection.service';
import { TranslateService } from '@ngx-translate/core';
import { takeUntil } from 'rxjs/operators';
import { videoAssetGroups } from '@configs/videoTitles';
import { ScoringTypeEnum } from '@configs/questions.config';
export interface DialogData {
  name: any;
  id: number;
}
export interface PeriodicElement {
  name: string;
  position: number;
  weight: number;
  symbol: string;
}

export interface getItemUuid {
  itemuuid: any;
  itemBasicDetails: any;
}

@Component({
  selector: 'app-item-details',
  templateUrl: './item-details.component.html',
  styleUrls: ['./item-details.component.scss'],
})
export class ItemDetailsComponent implements OnDestroy {
  @ViewChild('table') table: MatTable<any>;
  currentTab: any;
  routeSubscription: Subscription;

  itemuuid: any;
  itemStatus: any;
  tab1: boolean = false;
  getitemuuid: any;
  dataSource: any;
  itemId: any;
  questions: any;
  itemdetails: any;
  numberOfQuestions = 0;
  data: any;
  itemBasicData: any;
  isPublished = false;
  selectedTabIndex = 0;
  itemBasicDetails = {
    itemBankName: '',
    itemDescription: '',
    collectionId: '',
    itemBankId: '',
    isPublished: false,
  };
  setP: boolean;
  questionId: any;
  collectionId: any;
  testId: any;
  itemBankNameDisplay: any;
  itemBankNameDescription: any;
  isNoQuestions = false;
  ItemIdQue: any;
  globalcollectionuuid: any;
  itemStatusList: any = [];
  itemStatusId: any;
  private unsubscribe: Subject<void> = new Subject<void>();
  isHidden = false;
  videoLinks: any;
  hideShowVideoicon: any;
  videoAssetGroups = videoAssetGroups;
  hoverVideoApiCall: boolean = false;
  ScoringTypeEnum = ScoringTypeEnum;
  styleGroupSubscription: Subscription;
  StyleList: any;

  constructor(
    private itemService: ItemService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private questionService: QuestionService,
    private dialog: MatDialog,
    public roleSer: RoleManagementService,
    private webErrorService: WebErrorService,
    public CollectionService: CollectionService,
    public translate: TranslateService
  ) {
    this.onTrainingIcon(videoAssetGroups.ItemManagementDetails);
    this.itemService.videoIcon.subscribe(video =>{
      this.videoLinks = video;

      document.onclick = (args: any) : void => {
        if(args.target.className != 'trainingIcon') {
          this.isHidden = false;
        }
      }
    });
    this.globalcollectionuuid = JSON.parse(
      sessionStorage.getItem('defaultcollectionuuid')
    );

    this.questionService.reloadList.subscribe(data => {
      if (data) {
        // this.itemService.getItemStatus().subscribe(data => {
        //   this.itemStatusList = data.items;
          this.getItemData();
        // });
      }
    })
    this.itemService.questionCountUpdate.subscribe(data => { this.numberOfQuestions = data;});
    this.itemService.updateItemName.subscribe((resValue) => this.itemBankNameDisplay = resValue);
    this.itemService.getEditedItem.subscribe((resData) => {
      if (resData?.data != undefined) {
        this.itemBankNameDisplay = resData?.data?.itemBankName;
        this.itemBankNameDescription = resData?.data?.itemDescription;
      }
    })
    this.testId = this.router.getCurrentNavigation()?.extras?.state?.testId;
    this.routeSubscription = this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(url =>
      this.itemService.getItemStatus().subscribe(data => {
        this.itemStatusList = data.items;
        this.getItemData()
      })
    );

    this.itemService.getStyleGroups(JSON.parse(sessionStorage.defaultcollectionid)).subscribe(data => {
      this.itemService.styleGroup.next(data.data);
    });

    // this.translate.stream('items.statusArray').pipe(takeUntil(this.unsubscribe)).subscribe(translation => {
    //   this.itemStatusList = translation;
    // });

    this.itemService.getItemStatusList.subscribe(itemS => {
      this.itemStatusList = itemS;
    });
  }

  ngAfterViewInit(): void {
    document.onclick = (args: any) : void => {
      if(args.target.className != 'trainingIcon') {
        this.isHidden = false;
      }
    }
  }

  onTrainingIcon(groupName) {
    if (!this.hoverVideoApiCall) {
      this.itemService.videoTutorial(groupName).subscribe(video => {
        this.videoLinks = video.data;
        this.hoverVideoApiCall = true;
      });
    }
  }

  open_in_new_window(features, link) {
    var new_window;
    if(features !== undefined && features !== '') {
      new_window = window.open('', '_blank', features);
    }
    else {
      new_window = window.open('', '_blank');
    }

    let video = '<video controls controlsList="nodownload" style="width: 100%; height: 100vh;"><source src="' + link + '" type="video/mp4" /></video>'

    if(link !== null && link !== '') {
      new_window.document.write('<!doctype html><html><head><title>Video Player</title><meta charset="UTF-8" /></head><body style="padding: 0; margin: 0;" oncontextmenu="return false">' + video + '</body></html>');
    }
  }

  ngOnDestroy(): void {
    if (this.routeSubscription) { this.routeSubscription.unsubscribe(); }
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  getItemData() {
    this.itemService.updateStatus.subscribe((isItemDisable) => {
      if (isItemDisable) {
        this.isPublished = isItemDisable;
        this.itemStatus = this.itemStatusList[0].itemStatus;
        this.itemStatusId = this.itemStatusList[0].itemStatusId;
      }
    });

    this.itemId = sessionStorage.getItem('itemuuidId') //this.activatedRoute.snapshot.paramMap.get('id');
        this.collectionId = sessionStorage.defaultcollectionid;
    this.itemService.getItemDetails(this.itemId).subscribe((resdata) => {
      console.log('item details')
      this.data = resdata;
            // this.itemService.itemDetails.next(resdata?.data); //commented because of multiple api calls
      this.getitemuuid = resdata?.data?.itemuuId;
      this.itemService.getItemuuid(this.getitemuuid);
      this.itemBankNameDisplay = resdata?.data?.itemBankName;
      this.itemBankNameDescription = resdata?.data?.itemDescription;
      this.itemStatus = this.itemStatusList.filter(d => d.itemStatusId === resdata?.data?.statusId)[0].itemStatus;
      this.itemStatusId = resdata?.data?.statusId;
      if (resdata?.data.scoringTypeId === ScoringTypeEnum.On180360Degree) {
        let itemuuid = resdata?.data.itemuuId == undefined ? resdata?.data.itemuuid : resdata?.data.itemuuId;
        let styleGroupid = resdata.styleGroupid == undefined ? resdata?.data.stylegroupid : resdata?.data.styleGroupid;

        this.itemService.getItemStatus().subscribe(data => {
          this.itemStatusList = data.items;
        });

        this.styleGroupSubscription = this.itemService.getStylesBasedOnStyleGroup(itemuuid, styleGroupid).subscribe(styles => {
          this.StyleList = styles.data;
          this.itemService.StyleList.next(styles.data);
        },
        (error) => {this.styleGroupSubscription.unsubscribe();});
      }
      this.getItemDetails(resdata);
      if (resdata?.data?.questions == 0) {
        this.isNoQuestions = true;
      } else {
        this.questions = resdata?.data?.questions;
      }
    }, (error: any) => {
      this.webErrorService.handleAPIErrors(error);
    });
  }

  openNewItemDialog(): void {
    if(this.roleSer.accessData && this.roleSer.accessData.insertAllowed || this.roleSer.accessData.updateAllowed){
      this.dialog.open(CreateNewItemComponent, { minWidth: '650px', data: { itemuuid: this.getitemuuid, itemBasicDetails: this.itemBasicDetails } });

    }
  }

  getQuestionCount(questionCount) {
    this.numberOfQuestions = questionCount;
  }

  getItemDetails(itemBasicData: any) {
    this.numberOfQuestions = itemBasicData?.data?.questions?.length;
    this.itemService.itemQuestionCount(this.numberOfQuestions);
    this.questions = new MatTableDataSource(itemBasicData?.data?.questions);
    this.itemBasicDetails['itemBankName'] = itemBasicData?.data?.itemBankName;
    this.itemBasicDetails.itemDescription =
      itemBasicData?.data?.itemDescription;
    this.itemBasicDetails.collectionId = this.collectionId;
    this.itemBasicDetails.itemBankId = itemBasicData?.data?.itemBankId;
    this.ItemIdQue = this.itemBasicDetails.itemBankId;
    if (itemBasicData?.data?.statusId == this.itemStatusList[0]?.itemStatusId) {
      this.isPublished = true;
      this.itemBasicDetails.isPublished = true;
    } else {
      this.isPublished = false;
      this.itemBasicDetails.isPublished = false;
    }
  }

  navigateToSelectQuestionsType() {
    sessionStorage.setItem('ItemIdQue', this.ItemIdQue);
    this.router.navigate(['./selectquestiontype'], {
      relativeTo: this.activatedRoute,
      state: { itemId: this.itemId },
    });
  }

  navigateToItemLanding() {
    sessionStorage.removeItem('TestId');
    sessionStorage.removeItem('ItemIdQue');
    this.router.navigate(['../'], { relativeTo: this.activatedRoute });
  }

  navigateToItem() {
    this.router.navigate(['../'], { relativeTo: this.activatedRoute });
  }

  onChangeTab(event: MatTabChangeEvent) {
    this.tab1 = true;
    this.itemService.videoIcon.next(true);
    this.currentTab = event.tab.textLabel;
    this.selectedTabIndex = event.index;
  }
}

